import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/xampp/htdocs/clientesapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import request from './clientapi_conection';

function getResourece(resource) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return new Promise(function (resolve) {
    setTimeout(function () {
      request({
        url: resource,
        method: 'get',
        params: params
      }).then(function (request) {
        // saveInLocal(resource, request)
        resolve(request);
      });
    }, 1000);
  });
}

export function getPrestamos(_x, _x2, _x3) {
  return _getPrestamos.apply(this, arguments);
}

function _getPrestamos() {
  _getPrestamos = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(documento_id, numero_documento, params) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", getResourece('/creditopaginado/' + documento_id + '/' + numero_documento + params));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getPrestamos.apply(this, arguments);
}

export function viewPrestamo(_x4, _x5, _x6) {
  return _viewPrestamo.apply(this, arguments);
}

function _viewPrestamo() {
  _viewPrestamo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(documento_id, numero_documento, params) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", getResourece('credito/' + documento_id + '/' + numero_documento + '/' + params + '/cuotas'));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _viewPrestamo.apply(this, arguments);
}

export function getPersona(_x7) {
  return _getPersona.apply(this, arguments);
}

function _getPersona() {
  _getPersona = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(params) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", getResourece('/applicant/' + params));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getPersona.apply(this, arguments);
}